var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlackNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15447_2022)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8672 -0.0390625C14.4141 -0.0390625 14.9609 -0.0390625 15.5078 -0.0390625C17.4057 0.465948 18.5385 1.68991 18.9062 3.63281C18.9453 5.22114 18.9584 6.80968 18.9453 8.39844C17.1714 8.43242 15.4006 8.39336 13.6328 8.28125C11.6332 7.63437 10.5655 6.25416 10.4297 4.14062C10.5947 1.93206 11.7405 0.538837 13.8672 -0.0390625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.983,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4135 -0.0390625C24.9604 -0.0390625 25.5073 -0.0390625 26.0542 -0.0390625C27.7921 0.409726 28.8989 1.50348 29.3745 3.24219C29.5021 7.19834 29.5282 11.1566 29.4526 15.1172C29.0385 17.4859 27.6322 18.7619 25.2339 18.9453C22.8505 18.7952 21.4442 17.5452 21.0151 15.1953C20.9391 11.2084 20.9652 7.22408 21.0932 3.24219C21.5689 1.50348 22.6757 0.409726 24.4135 -0.0390625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.984,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.0390625 15.5064C-0.0390625 14.9595 -0.0390625 14.4126 -0.0390625 13.8658C0.415556 12.0961 1.53534 10.9893 3.32031 10.5454C7.14666 10.4186 10.9748 10.3926 14.8047 10.4673C16.7462 10.5984 18.0613 11.575 18.75 13.397C19.279 15.5619 18.6149 17.2415 16.7578 18.4361C16.2877 18.6709 15.7929 18.8272 15.2734 18.9048C11.2341 18.9812 7.19762 18.9551 3.16406 18.8267C1.46694 18.3147 0.399229 17.2079 -0.0390625 15.5064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.982,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.96 14.1016C39.96 14.5182 39.96 14.9349 39.96 15.3516C39.5225 17.3384 38.2985 18.5233 36.2881 18.9062C34.6997 18.9453 33.1112 18.9584 31.5225 18.9453C31.5094 17.2524 31.5225 15.5597 31.5615 13.8672C32.1233 11.717 33.5165 10.5712 35.7412 10.4297C37.5173 10.5288 38.8064 11.3621 39.6084 12.9297C39.7529 13.323 39.87 13.7137 39.96 14.1016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.974,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.0390625 25.8994C-0.0390625 25.4828 -0.0390625 25.0661 -0.0390625 24.6494C0.426453 22.5123 1.75458 21.3014 3.94531 21.0166C5.45551 20.9776 6.96592 20.9645 8.47656 20.9776C8.50625 22.6985 8.46719 24.4172 8.35938 26.1338C7.84438 28.003 6.63343 29.1098 4.72656 29.4541C2.71 29.5967 1.23865 28.7764 0.3125 26.9932C0.169545 26.6272 0.0523573 26.2626 -0.0390625 25.8994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.984,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5084 39.9609C14.9615 39.9609 14.4146 39.9609 13.8678 39.9609C12.1319 39.5142 11.0252 38.4205 10.5475 36.6797C10.4206 32.8012 10.3946 28.921 10.4693 25.0391C10.8053 22.5548 12.2245 21.2006 14.7271 20.9766C17.0454 21.1987 18.4387 22.4487 18.9068 24.7266C18.9828 28.7395 18.9568 32.7498 18.8287 36.7578C18.3167 38.4549 17.2099 39.5227 15.5084 39.9609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.984,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9609 24.4127C39.9609 24.9596 39.9609 25.5064 39.9609 26.0533C39.523 27.7546 38.4552 28.8613 36.7578 29.3736C32.7238 29.5018 28.6873 29.5278 24.6484 29.4518C22.3548 28.9803 21.1309 27.5741 20.9766 25.233C21.1027 23.2091 22.1184 21.855 24.0234 21.1705C24.3314 21.0929 24.6439 21.0408 24.9609 21.0143C28.869 20.9395 32.7752 20.9655 36.6797 21.0924C38.4184 21.568 39.5122 22.6748 39.9609 24.4127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.979,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9756 39.9611C25.4547 39.9611 24.934 39.9611 24.4131 39.9611C22.4775 39.4445 21.3447 38.1945 21.0147 36.2111C20.9756 34.6488 20.9626 33.0863 20.9756 31.5236C22.7495 31.4896 24.5203 31.5287 26.2881 31.6408C28.6778 32.4732 29.7065 34.1529 29.374 36.6798C28.8894 38.4536 27.7566 39.5473 25.9756 39.9611Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15447_2022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackNew);
export default __webpack_public_path__ + "static/media/slackNew.d13c1f5a837e88fcc568a0c2b779ef0b.svg";
export { ForwardRef as ReactComponent };